export default __webpack_public_path__ + "static/SONY_IMX335_Day_thumb-f4595a08256484d7d506f1d2d45cb501.webp";